export var SIGNOUT = 'SIGNOUT';



// WEBPACK FOOTER //
// ./src/actions/auth/SignOut.js